import { urlBuilder } from '@makemydeal/dr-common-utils';
import type { StateTree } from '@makemydeal/dr-dash-types';

import { getServicesBff } from '../selectors/config';

/**
 * Builds a payment service URL for the given BFF proxy route.
 *
 * All payment requests are routed through the BFF `privateApiProxy` Lambda.
 * The BFF controls whether to call the public or private payment service endpoint
 * based on the `enablePrivateAPIGateway_F243851` feature toggle — keeping the
 * public/private routing decision entirely server-side.
 */
const buildPaymentServiceUrl = (state: StateTree, bffRoute: string): string => {
    const bff = getServicesBff(state);
    return urlBuilder.buildFromConfig(bff, bffRoute) || '';
};

/** Payment orchestrator with dealer ID (UPQ). */
export const getPaymentUrl = (state: StateTree): string => buildPaymentServiceUrl(state, 'payment-orchestrator-with-dealer-id');

/** Fees types endpoint. */
export const getFeesTypesUrl = (state: StateTree): string => buildPaymentServiceUrl(state, 'feesTypes');

/** Incentives endpoint. */
export const getIncentivesUrl = (state: StateTree): string => buildPaymentServiceUrl(state, 'incentives');

/** Program orchestrator endpoint. */
export const getProgramOrchestratorUrl = (state: StateTree): string => buildPaymentServiceUrl(state, 'program-orchestrator');

/** User program rolls endpoint. */
export const getUserProgramRollsUrl = (state: StateTree): string => buildPaymentServiceUrl(state, 'user-program-rolls');
